<template>
    <Plot v-bind:apitoken="set_apitoken"  style="margin:10vh"/>
</template>

<script>
    require('@/assets/css/new.css')
    import Plot from '@/components/Plot.vue'
    export default {
        components: {
            Plot,
        },
        data(){
            return {
                set_apitoken : ""
            }
        },
        computed: {
        },
        created(){
            this.set_apitoken = this.$route.query.api
            this.auth_token = localStorage.getItem('authtoken')
            if (this.auth_token == null || this.auth_token == 'undefined' || this.auth_token == '') {
                this.$router.push("/")
            }
        },
        methods: {
            
        },
    }
</script>
